import { render, staticRenderFns } from "./BookingActions.vue?vue&type=template&id=52965214&scoped=true&"
import script from "./BookingActions.vue?vue&type=script&lang=js&"
export * from "./BookingActions.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52965214",
  null
  
)

export default component.exports